import React, { useState } from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";

const InputBox = React.forwardRef(
  (
    {
      label,
      type,
      placeholder = "",
      required = false,
      readOnly = false,
      maxLength,
      error,
      value,
      onChange,
      ...rest
    },
    ref
  ) => {
    const [bool, setbool] = useState(false);
    // console.log("rest", rest.valueOf());
    return (
      <div className="form-floating">
        <input
          placeholder={placeholder}
          readOnly={readOnly}
          maxLength={maxLength}
          value={value}
          type={bool ? "text" : type}
          ref={ref}
          className={`form-control ${error ? "is-invalid" : ""}`}
          {...rest}
        />
        {label && (
          <label className="">
            {label} {required && <span className="text-danger">*</span>}
          </label>
        )}
        {type === "password" &&
          (bool && value ? (
            <i
              onClick={() => setbool(!bool)}
              style={{
                position: "absolute",
                right: "5px",
                top: "11px",
              }}
            >
              <IoEyeOutline color="black" size={20} />
            </i>
          ) : (
            <i
              onClick={() => setbool(!bool)}
              style={{
                position: "absolute",
                right: "5px",
                top: "11px",
              }}
            >
              <IoEyeOffOutline color="black" size={20} />
            </i>
          ))}
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    );
  }
);

export default InputBox;
